// extracted by mini-css-extract-plugin
export default {"main":"ItemsInCart_main__Wn9Jw"};